import React ,{useState} from 'react';
import Posts from  '../../components/Posts/Posts';
import {useDispatch} from 'react-redux';
import Form from '../../components/Form/Form';
import { getPosts ,getPostsBySearch } from '../../actions/posts';
import {Container,Grow, Grid,Paper ,AppBar,TextField,Button} from '@material-ui/core';
import useStyles from './styles.js';
import Pagination from '../Pagination';
import {useNavigate ,useLocation } from 'react-router-dom';
import ChipInput from 'material-ui-chip-input';



function useQuery() {
    return new URLSearchParams(useLocation().search);
}



const Home = () => {
    const classes = useStyles();
    const [currentId,setCurrentId] = useState(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const query = useQuery();
    const page = query.get('page') || 1;
    const searchQuery = query.get('searchQuery');
    const [search,setSearch] = useState('');
    const [tags, setTags] = useState([]);
    

    const searchPost = (e) => {
      e.preventDefault();
      if(search.trim() || tags.length>0){
        dispatch(getPostsBySearch({search,tags:tags.join(',')}))
        navigate(`/posts/search?searchQuery=${search || 'none' }&tags=${tags.join(",")}`)
      }

      else {
        dispatch(getPosts());
        navigate("/posts");
      }


    }
    
    const handleKeyPress = (e) => {

      if(e.keycode === 13)
      {
          searchPost();
      }



    }
    

    const handleAddChip = (tag) => setTags([...tags, tag]);

    const handleDeleteChip = (chipToDelete) => setTags(tags.filter((tag) => tag !== chipToDelete));
    


  return (
    <Grow in>
          <Container maxWidth="xl">
                <Grid className={classes.mainContainer} container justifyContent="space-between" alignItems='stretch' spacing={3}>
                  <Grid item xs={12} sm={6} md={9}>
                    <Posts setCurrentId={setCurrentId} />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                  <AppBar className={classes.appBarSearch} position="static" color='inherit' > 
                    <TextField

                      name="search"
                      variant='outlined'
                      value={search}
                      label="Search Memories"
                      fullWidth
                      onChange={(e)=>setSearch(e.target.value)}
                      onKeyPress={handleKeyPress}
                    
                     />

                    <ChipInput
                        style={{ margin: '10px 0' }}
                        value={tags}
                        onAdd={(chip) => handleAddChip(chip)}
                        onDelete={(chip) => handleDeleteChip(chip)}
                        label="Search Tags"
                        variant="outlined"
                    />

                    <Button onClick={searchPost} classes={classes.searchButton} color="primary" variant='contained'>Search</Button>
                  
                   </AppBar>
                      <Form currentId={currentId} setCurrentId={setCurrentId} />
                      {
                        (!searchQuery && !tags.length) && (
                          <Paper elevation={6} className={classes.pagination}>
                            <Pagination page={page} />
                          </Paper>
                        )
                      }
                      
                  </Grid>
                </Grid>
          </Container>
      </Grow>
  )
}

export default Home